import React from "react";
import IstoricTabel from "../../../common/Istoric/IstoricTabel";

const istoricVanzari = () => {
  return <IstoricTabel url={`https://jellyfish-app-f8wy8.ondigitalocean.app/api/istoric`} />;
};

export default istoricVanzari;
